import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { WelcomeSystemINCCompanySupportRate } from 'constants/enum';
import { Commons, UseStats } from 'components';
import * as cm_action from 'actions/commons';
import * as usg_action from 'actions/usage';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import storage from 'helpers/storage';
import download from 'downloadjs';

moment.tz.setDefault('Asia/Seoul');

class DeductionSikdaeCNT extends Component {
  constructor(props) {
    const company = storage.get('company');
    const companyId = company && company.user && company.user.company ? company.user.company.id : null;
    const isWelcomeSystemINC =
      companyId === '64667880-2B25-4EB2-8FF0-9F5129F15925' || companyId === '2BA41B58-8716-464E-A2A3-ECB9FC974528';

    super(props);
    this.state = {
      page: 1,
      pagerow: 15,
      totalcount: null,
      staffModal: {
        open: false,
        size: 'large'
      },
      staff: {
        name: '',
        id: ''
      },
      isWelcomeSystemINC,
      companySupportRate: isWelcomeSystemINC ? WelcomeSystemINCCompanySupportRate.FORTY_FIVE_PERCENT : null // 기본값: 45% 지원
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);
    // 식대 사용 통계 리스트
    this.deductionUsageStatList();
  }

  componentDidMount() {
    cm.mainTitle('삼성물산 급여공제');
  }

  shouldComponentUpdate(nextProps, nextState) {
    let result = true;

    const nCommonsProps = {
      dateType: nextProps.dateType,
      date: nextProps.date,
      depth: nextProps.depth
    };

    const bCommonsProps = {
      dateType: this.props.dateType,
      date: this.props.date,
      depth: this.props.depth
    };

    if (JSON.stringify(nCommonsProps) !== JSON.stringify(bCommonsProps)) {
      result = false;
    }

    return result;
  }

  modalAction = (type, dimmer) => {
    if (type === 'open') {
      this.staffSel(1, null);
    }

    this.setState({
      dimmer,
      staffModal: { open: dimmer }
    });
  };

  staffSel = async (page, keyword) => {
    const { cmAPI } = this.props;

    const params = {
      page,
      pagerow: 10,
      keyword
    };

    try {
      await cmAPI.staffSel(params);
    } catch (e) {
      console.log('###### staffSel error : ', e);
    }
  };

  choiceStaff = (data) => {
    this.setState({
      staff: {
        name: data ? data.staff.name : '',
        id: data ? data.staff.id : ''
      },
      staffModal: { open: false }
    });
  };

  submitForm = async (e) => {
    e.preventDefault();

    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }

    await this.setState({ page: 1 });
    this.deductionUsageStatList();
  };

  deductionUsageStatList = async () => {
    const { date, usageAPI } = this.props;
    const { page, pagerow, totalcount, staff, companySupportRate } = this.state;

    const params = {
      startDate: date
        ? date.sDate
        : moment()
            .startOf('month')
            .format('LLL'),
      endDate: date ? date.eDate : moment().format('LLL'),
      page,
      pagerow,
      userId: staff.id === '' ? null : staff.id,
      totalcount: page !== 1 ? totalcount : null,
      companySupportRate
    };

    await usageAPI.usageStatList(params);

    const { usageStat } = this.props;

    if (usageStat && usageStat.data) {
      const { paging } = usageStat.data;
      this.setState({ totalcount: paging.totalcount });
    }

    const { cmAPI } = this.props;

    cmAPI.changeExcel({
      excel: params
    });
  };

  pageClick = async (page) => {
    await this.setState({ page });
    this.deductionUsageStatList();
  };

  changeCompanySupportRate = (rate) => {
    this.setState((prev) => ({ ...prev, companySupportRate: rate }));
  };

  handleExcelDownload = async () => {
    const { cmAPI, date } = this.props;
    const { page, pagerow, totalcount, staff, companySupportRate, isWelcomeSystemINC } = this.state;

    const company = storage.get('company');

    if (company && company.user && company.user.company && company.user.company.id) {
      const excelUrl = isWelcomeSystemINC
        ? '/stat/v1/company/welcome-system-inc/salary-deduction/download'
        : '/stat/v1/company/samsung-cnt/salary-deduction/download';

      const excelResult = {
        startDate: date
          ? date.sDate
          : moment()
              .startOf('month')
              .format('LLL'),
        endDate: date ? date.eDate : moment().format('LLL'),
        page,
        pagerow,
        userId: staff.id === '' ? null : staff.id,
        totalcount: page !== 1 ? totalcount : null,
        companySupportRate
      };

      const params = {
        com: company,
        excel: { url: excelUrl, method: 'get' },
        excelResult: { excel: excelResult }
      };

      let header = null;
      await cmAPI.excelDownload(params).then((result) => {
        const { value } = result;
        if (value) {
          header = value.headers['content-disposition'];
          header = header.split('=');
        }
        download(value.data, decodeURIComponent(header[1]));
        toastr('top-right', 'success', `엑셀파일 생성 완료 되었습니다.`);
      });
    }
  };

  render() {
    const { usageStat } = this.props;
    const { page, pagerow, staffModal, dimmer, staff, companySupportRate } = this.state;

    const modal = {
      open: staffModal.open,
      size: staffModal.size,
      dimmer,
      close: this.modalAction
    };

    const sb = {
      fn: {
        choiceStaff: this.choiceStaff
      }
    };

    const listFn = {
      page,
      pagerow,
      pageClick: this.pageClick
    };

    let loading = '';
    if (!usageStat) {
      loading = <Commons.LoadingBar />;
    }
    const company = storage.get('company');
    const companyId =
      company && company.user && company.user.company && company.user.company.id ? company.user.company.id : null;
    const isWelcomeSystemINC =
      companyId === '64667880-2B25-4EB2-8FF0-9F5129F15925' || companyId === '2BA41B58-8716-464E-A2A3-ECB9FC974528';

    return (
      <main className="sus">
        {loading}
        {/* <Button inverted color="green" onClick={this.downloadExcel} style={{ width: '184px' }}>
          엑셀 다운로드
        </Button> */}
        <div className="top-btn button" style={{ right: 200 }}>
          <Button
            inverted
            color="green"
            onClick={this.handleExcelDownload}
            style={{ width: '184px', marginRight: '-180px', marginTop: '-1px' }}
          >
            엑셀 다운로드
          </Button>
        </div>

        <UseStats.DeductionSearchBox
          modalAction={this.modalAction}
          staff={staff}
          fn={sb.fn}
          dateType="DD"
          companySupportRate={companySupportRate}
          isWelcomeSystemINC={isWelcomeSystemINC} // 웰컴 서비스 이앤씨 화면임을 표시
          onCompanySupportRateChange={this.changeCompanySupportRate}
          submitForm={this.submitForm}
        />

        <UseStats.StatsList listFn={listFn} />
        {staffModal.open ? (
          <Commons.StaffSearchModal modal={modal} staffSel={this.staffSel} choiceEvent={this.choiceStaff} />
        ) : null}
      </main>
    );
  }
}

export default connect(
  (state) => ({
    // common function call
    dateType: state.commons.dateType,
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    division: state.commons.division,
    depth: state.commons.depth,
    orgIdx: state.commons.orgIdx,

    staffList: state.commons.staff,
    storeList: state.commons.companyStore,

    groupIdx: state.commons.group,
    policyIdx: state.commons.policy,
    // usage function
    usageStat: state.usage.usageStats
  }),
  (dispatch) => {
    const company = storage.get('company');
    const companyId =
      company && company.user && company.user.company && company.user.company.id ? company.user.company.id : null;
    const isWelcomeSystemINC =
      companyId === '64667880-2B25-4EB2-8FF0-9F5129F15925' || companyId === '2BA41B58-8716-464E-A2A3-ECB9FC974528';
    return {
      cmAPI: bindActionCreators(
        {
          staffSel: cm_action.StaffSel,
          changeExcel: cm_action.ChangeExcel,
          excelDownload: cm_action.ExcelDownload
        },
        dispatch
      ),
      usageAPI: bindActionCreators(
        {
          usageStatList: isWelcomeSystemINC
            ? usg_action.DeductionWelcomeSystemINCUsageStatsList
            : usg_action.DeductionSamsungCNTUsageStatsList
        },
        dispatch
      )
    };
  }
)(DeductionSikdaeCNT);
